export const ACTION_MODAL_HEIGHT = 575
export const FULL_COLLAPSE_PADDING = { title: '14px 16px', content: '4px 16px 14px' }
export const TITLE_COLLAPSE_PADDING = { title: '14px 16px' }
export const NO_SIDE_COLLAPSE_PADDING = { title: '14px 0', content: '4px 0 14px' }
